import CountUp from "react-countup";
import { useEffect, useState } from "react";
import { FaLeaf, FaUsers, FaMapMarkerAlt, FaHandsHelping } from "react-icons/fa";

const stats = [
  {
    icon: <FaLeaf size={32} />,
    value: 300,
    suffix: "+",
    label: "Sahaja Yoga Centers in India",
    bg: "bg-green-100",
    text: "text-green-800",
  },
  {
    icon: <FaUsers size={32} />,
    value: 150000,
    suffix: "+",
    label: "People Practicing Meditation",
    bg: "bg-emerald-50",
    text: "text-emerald-800",
  },
  {
    icon: <FaMapMarkerAlt size={32} />,
    value: 25,
    suffix: "+",
    label: "Centers in Gujarat",
    bg: "bg-indigo-100",
    text: "text-indigo-800",
  },
  {
    icon: <FaHandsHelping size={32} />,
    value: 500,
    suffix: "+",
    label: "Trained Staff",
    bg: "bg-rose-100",
    text: "text-rose-800",
  },
];

const ImpactStats = () => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const statSection = document.getElementById("impact-stats");
      const rect = statSection?.getBoundingClientRect();
      if (rect && rect.top < window.innerHeight && !inView) {
        setInView(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [inView]);

  return (
    <section id="impact-stats" className="bg-[#f9fdfc] py-20">
      {/* Section Heading */}
      <div className="text-center mb-12">
        <p className="text-sm uppercase text-green-700 tracking-wider font-semibold">Our Presence</p>
        <h2 className="text-3xl font-bold text-gray-800">Impact Across the Region</h2>
        <p className="text-gray-600 mt-2 max-w-xl mx-auto text-sm">
          Sahaja Yoga is practiced and supported by thousands across India and Gujarat. Here’s a glimpse of our reach.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`rounded-xl p-6 shadow-sm ${stat.bg} ${stat.text} transition hover:shadow-md`}
            data-aos="zoom-in"
            data-aos-delay={index * 100}
          >
            <div className="mb-3">{stat.icon}</div>
            <h3 className="text-4xl font-bold">
              {inView && <CountUp end={stat.value} duration={2} />} {stat.suffix}
            </h3>
            <p className="text-sm mt-2 font-medium">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImpactStats;
